/** @jsxImportSource @emotion/react */
import React from 'react';
import { quickFilterItemStyles } from './quick-filter-item.styles';

type Props = {
    name: string;
    value: boolean | undefined;
    onClick: (value: boolean | undefined) => void;
};

const QuickFilterItem = (props: Props) => {
    const { name, value, onClick } = props;
    const handleClick = () => {
        onClick(value === undefined ? true : undefined);
    };

    return (
        <div
            css={
                value
                    ? [quickFilterItemStyles.root, quickFilterItemStyles.active]
                    : quickFilterItemStyles.root
            }
            onClick={handleClick}>
            {name}
        </div>
    );
};

export default QuickFilterItem;
